'use client'
import React from 'react'
import { Tabs } from '../../molecules/Tabs'

export interface TabsWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
    tabContent: React.ReactNode
}

export const TabsWrapper = ({ children, tabContent, ...props }: TabsWrapperProps) => {
    return (
        <div {...props} className={`tabs-wrapper flex flex-col min-h-full ${props.className ?? ''}`}>
            <Tabs>{children}</Tabs>
            <div className="flex flex-col grow">{tabContent}</div>
        </div>
    )
}
